import React from 'react'
import Title from '../../title/title.jsx'

const description10 = () => {
  return (
    <div>
      <Title text="YAKINDA" size='l' align='left'/>
    </div>
  )
}

export default description10